import styled from 'styled-components';
import { Input } from '../common';

export const StyledForm = styled.form`
  background: #fff;
`;

export const StyledFormLegend = styled.legend`
  display: block;
  margin-bottom: 0.5em;
  color: #003264;
  font-size: 1em;
  font-weight: 300;
  line-height: 1.25em;
`;

export const StyledFormLabel = styled.label`
  display: block;
  margin-bottom: 0.5em;
  color: ${(props) => (props.disabled ? '#666666' : '#003264')};
  font-size: 1em;
  font-weight: 300;
  line-height: 1.25em;
`;

export const StyledFormFieldset = styled.fieldset`
  margin-bottom: 1.5em;
`;

export const StyledGenderRadioInputs = styled.div`
  display: flex;
`;

export const StyledGenderRadioInputAndLabel = styled.div`
  display: flex;
  margin-right: 0.5em;
`;

export const StyledFormGroup = styled.div`
  margin-bottom: 1.5em;
`;

export const StyledInputGroup = styled.div`
  display: flex;
`;

export const StyledStreetInput = styled(Input)`
  flex: 4 1 0;
  margin-right: 1em;
`;

export const StyledHouseNumberInput = styled(Input)`
  flex: 1 1 0;
  margin-left: 1em;
`;

export const StyledPostCodeInput = styled(Input)`
  flex: 1 1 0;
  margin-right: 1em;
`;

export const StyledCityInput = styled(Input)`
  flex: 4 1 0;
  margin-left: 1em;
`;

export const StyledAdditionalDetailsText = styled.p`
  margin-top: 1.5em;
  margin-bottom: 1.5em;
`;

export const StyledButtonContainer = styled.div`
  margin-top: 1.5em;
  width: 100%;

  button {
    width: auto;
    margin-left: auto;
    margin-right: auto;
  }
`;
